/* src/app/order/partials/order-quick-form/order-quick-form.component.scss */
/*# sourceMappingURL=order-quick-form.component.css.map */
